export const user_manual ="user-manual"
const user_manual_route = {
    home: `/shoal/${user_manual}/report/:survey_id/:response_id`,
    surveyQuizUserManual: `/shoal/${user_manual}/survey/:id`,
}

export default user_manual_route